module.exports = __webpack_public_path__ + "media/img/agents_bg_navy-bb8eff13fde1d5cd80b9f3efdc14091e.png";